import React from 'react';
import skill from '../../../assets/images/aboutMe/skill.png';

const SkillList = () => {
  return(
    <div>
      <img className="ui small centered image" src={skill} alt="skills" /> 
      <h3>Programming languages</h3>
      <h4> Worked with</h4>
      <p>PHP, HTML, MYSQL, JavaScript</p>
      <h3>Tech stacks</h3>
      <p>Symfony, Laravel, NodeJS, ReactJS</p>
      <p>AWS Lambda, AWS SQS, AWS SNS</p>
      <p>AWS DynamoDB, AWS API Gateway, AWS Cloudformation</p>
      <p>Docker</p>
      <h4>Studied</h4>
      <p>C, C++, C#, Java</p>
    </div>
  )
}

export default SkillList;